import React from 'react';
import { Link } from 'react-router-dom';
import Banner from '../sections/Banner';
import Header from '../sections/Header';
import Footer from '../sections/Footer';
import { Container, Row, Col } from 'reactstrap';
import { imgUrlGenerate, removeHyphensAndCapitalize } from '../../helpers';
import { title, icon, redirectLink } from './ThankYouPage.module.css';
import { THANK_YOU, CONTACT_US_LINK } from '../../utils/constants';
import Image from '../../components/UI/Image';
import { string } from 'prop-types';

const ThankYouPage = ({ url }) => (
  <>
    <Banner pageType={THANK_YOU} title={removeHyphensAndCapitalize(url)}>
      <Container>
        <Header />
      </Container>
    </Banner>

    <Container>
      <Row>
        <Col lg={{ size: 8, offset: 2 }}>
          <div className="title">
            Tell us about your tastes
          </div>
          <Image className="beans-logo" src={imgUrlGenerate(`Beans_logo_dark.svg`)} alt="Beans Logo" />
          <p className={title}>Thank you so much for your request. <br /> We'll contact you as soon as possible. </p>
          <Image className={icon} src={imgUrlGenerate(`coffee_and_croissant.png`)} alt="Thank you" />

          <Link to={`/${CONTACT_US_LINK}/`} className={redirectLink}>
            Another ?
              <img src={imgUrlGenerate(`go_back-arrow.svg`)} alt='Go back' />
          </Link>
        </Col>
      </Row>
    </Container>

    <Footer />
  </>
)

ThankYouPage.propTypes = {
  url: string,
}

ThankYouPage.defaultProps = {
  url: '',
}

export default ThankYouPage
